import { useCallback } from 'react'
import { InfoOutlined } from '@mui/icons-material'

import { useAppDispatch } from 'app/hooks'
import { openWisDetailsModal } from 'app/entities/store/modalsSlice'
import { IStateAssessment } from 'features/RiskManagement/Assessments'

export interface IWISInfoButton {
  qraName?: string
  currentAssessment?: IStateAssessment
}

const WISInfoButton = ({ qraName, currentAssessment }: IWISInfoButton) => {
  const dispatch = useAppDispatch()

  const handleOpenModal = useCallback(() => {
    dispatch(openWisDetailsModal())
  }, [dispatch])

  if (qraName == null || currentAssessment == null) {
    return <></>
  }

  return (
    <button className='text-gray-700' onClick={handleOpenModal}>
      <InfoOutlined />
    </button>
  )
}

export default WISInfoButton
